import { qk, STALE_TIME } from "@secretaa/sdk-react";
import { useQueries } from "@tanstack/react-query";
import { api } from "../../app/api.ts";
import { useCurrentWorkspace } from "../../app/session.ts";
import { displayFieldOf, type MCollection } from "./manifest-view.ts";

/** Nhãn bản ghi của các collection đích (relation): id → tên hiển thị. v1 nạp tối đa 200 bản ghi / collection. */
export function useRecordLabels(projectId: string, targets: readonly MCollection[]) {
  const cur = useCurrentWorkspace()!;
  const results = useQueries({
    queries: targets.map((c) => ({
      queryKey: qk.records(cur.tenant, projectId, c.id, { lookup: true }),
      queryFn: () => api.data.query(cur.workspaceId, projectId, c.id, { limit: 200 }),
      staleTime: STALE_TIME.records,
    })),
  });
  const byCollection = new Map<string, { value: string; label: string }[]>();
  targets.forEach((c, i) => {
    const show = displayFieldOf(c);
    byCollection.set(
      c.id,
      (results[i]?.data?.data ?? []).map((r) => ({ value: r.id, label: show ? String(r.values[show.id] ?? r.id.slice(0, 8)) : r.id.slice(0, 8) })),
    );
  });
  const labelOf = (id: string) => {
    for (const list of byCollection.values()) {
      const hit = list.find((x) => x.value === id);
      if (hit) return hit.label;
    }
    return id.slice(0, 8);
  };
  return { byCollection, labelOf };
}
